<template>
  <ValidationObserver
    ref="dialogObserver"
    v-slot="{ valid }"
    slim
  >
    <AppDialog
      class="member-profile-field-dialog"
      :title="title"
      subtitle="This field will be added to all member profiles and can be viewed in reports."
      append-to-body
      show
      @close="closeDialog"
    >
      <div
        v-if="fieldError('base')"
        class="form-group has-error"
      >
        <span class="help-block">{{ fieldError('base') }}</span>
      </div>

      <form
        id="member-profile-field-form"
        autocomplete="off"
        @submit.prevent="onFormSubmit"
      >
        <ValidationProvider
          ref="nameProvider"
          rules="required"
          :title="form.title"
        >
          <div
            id="title"
            class="form-group mb-10"
            :class="{ 'has-error': fieldError('title') }"
          >
            <label
              class="control-label"
              for="title"
            >
              Field title
              <abbr title="required">*</abbr>
            </label>

            <AppInput
              v-model="form.title"
              class="form-control"
              placeholder="Field title"
              required
            />
            <span
              v-if="fieldError('title')"
              class="help-block"
            >
              {{ fieldError('title') }}
            </span>
          </div>
        </ValidationProvider>
      </form>

      <div class="people-addon-preview">
        <img
          :src="hubstaffBetaImage"
          alt="Hubstaff People Beta"
        />
        Try custom fields for free while the Hubstaff People add-on is in free BETA
      </div>

      <template id="footer">
        <div
          v-if="fieldError('member_profile_field')"
          class="has-error m-0"
        >
          <div class="help-block d-flex align-items-center justify-content-end">
            <i class="hi hi-info-filled mr-5" />
            Member profile field {{ fieldError('member_profile_field') }}
          </div>
        </div>

        <div class="d-flex">
          <AppButton
            v-if="editing"
            type="danger"
            @click="showDeleteProfileDialog(memberProfileField)"
          >
            Delete
          </AppButton>

          <div class="ml-auto">
            <AppButton
              class="mr-15"
              type="default"
              @click="closeDialog"
            >
              Cancel
            </AppButton>

            <button
              class="btn btn-primary"
              type="submit"
              form="member-profile-field-form"
              :disabled="!valid || form.processing"
            >
              Save
            </button>
          </div>
        </div>
      </template>
    </AppDialog>
  </ValidationObserver>
</template>
<script>
import { mapInertiaProps } from '@/utils/inertia';
import { applyTemplate } from '@/utils/url_template';
import { HUBSTAFF_PEOPLE_BETA_TRANSPARENT } from '@/rails_assets';

export default {
  name: 'MemberProfileFieldDialog',
  components: {},
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    memberProfileField: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hubstaffBetaImage: HUBSTAFF_PEOPLE_BETA_TRANSPARENT,
      form: this.$inertia.form({
        title: this.editing ? this.memberProfileField.title : null,
        key: this.editing ? this.memberProfileField.key : null,
        errors: this.errors,
      }),
    };
  },
  computed: {
    ...mapInertiaProps({
      organization: 'organization',
    }),
    disabled() {
      return this.memberProfileField.title;
    },
    title() {
      return `${this.editing ? 'Edit' : 'Add'} custom field`;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    showDeleteProfileDialog(field) {
      this.$emit('show-delete-dialog', field);
    },
    fieldError(field) {
      if (this.form.errors && this.form.errors[field]) {
        return this.form.errors[field][0];
      }
    },
    onFormSubmit() {
      const { origin } = window.location;
      const url = new URL(
        applyTemplate('/organizations/:id/update_member_profile_fields', { id: this.organization.id }),
        origin,
      );
      const organizationsUrlString = url.toString();

      this.form.transform((data) => {
        const payload = {};

        payload.title = data.title;
        payload.key = data.key;

        return { organization: { member_profile_field: payload } };
      });

      const options = {
        onSuccess: () => {
          window.analytics?.track('Custom field added', { field_name: this.form.title });
          this.$appMessage(`Member profile field ${this.editing ? 'updated' : 'added'}`);
          this.closeDialog();
        },
      };

      return this.form.post(organizationsUrlString, options);
    },
  },
};
</script>
